import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Label, FormGroup, FormText } from 'reactstrap';

export const ContactForm = ({ formErrors, handleInputChange, inputValues, onSubmitRegister, formValid }) => {
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        setDisabled(!formValid());
    }, [inputValues])

    return (
        <>
            <Form onSubmit={onSubmitRegister} className="form-login">
                <FormGroup className="required mb-3">
                    <Label for="name">Name</Label>
                    <Input type="text" name="name" id="name" invalid={formErrors.name === '' ? null : true} value={inputValues.name} onChange={handleInputChange} placeholder='John Doe'/>
                    {formErrors.name && <FormText color='danger'>{formErrors.name}</FormText>}
                </FormGroup>
                <FormGroup className="mb-3">
                    <Label for="phone">Phone Number</Label>
                    <Input type="number" name="phone" id="phone" invalid={formErrors.phone === '' ? null : true} value={inputValues.phone} onChange={handleInputChange} placeholder='+1-987-654-321'/>
                    {formErrors.phone && <FormText color='danger'>{formErrors.phone}</FormText>}
                </FormGroup>
                <FormGroup className="required mb-3">
                    <Label for="email">Email Address</Label>
                    <Input type="text" name="email" id="email" invalid={formErrors.email === '' ? null : true} value={inputValues.email} onChange={handleInputChange} placeholder='username@mail.com'/>
                    {formErrors.email && <FormText color='danger'>{formErrors.email}</FormText>}
                </FormGroup>
                <FormGroup className="required mb-3">
                    <Label for="comments">Description</Label>
                    <Input type="textarea" name="comments" id="comments" style={{ height: 250 }} invalid={formErrors.comments === '' ? null : true} value={inputValues.comments} onChange={handleInputChange} placeholder='Share your thoughts here..'/>
                    {formErrors.comments && <FormText color='danger'>{formErrors.comments}</FormText>}
                </FormGroup>
                <Button color="green-light" block type="submit" disabled={disabled} className='py-2 rounded-sm mb-3'>Send Message</Button>
            </Form>
        </>
    )
}
